import { useTranslation } from 'react-i18next'
import StatusBar from './StatusBar'
import { CrossSwapOrderStatus as OrderStatus } from '@tokenlon/v6-sdk'
import { getIsFailed, getIsSuccess } from './help'
import styled, { useTheme } from 'styled-components'

interface Props {
  status: OrderStatus
}

// 跨链交易包含源链交易和目标链交易
// 1. 源链 pending
// 2. 源链 success，目标链 pending
// 3. 源链 success，目标链 success
// 4. 源链 success，目标链 failed
// 5. 源链 failed
const CrossSwapOrderStatus: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const isFailed = getIsFailed(status)
  const isSuccess = getIsSuccess(status)

  const label = isSuccess
    ? t('order_status_successful')
    : isFailed
    ? t('order_status_failed')
    : t('order_status_processing')

  const labelColor = isSuccess ? theme.colors.statusSuccess : isFailed ? theme.colors.textDanger : theme.colors.textDisabled

  const tipText = isFailed
    ? t('cross_swap_order_status_failed_tip')
    : t('cross_swap_order_status_tip')

  return (
    <div>
      <StyledTradeStatus>
        <StatusBar status={status} />
        <StyledStatusLabel style={{ color: labelColor }}>
          {label}
        </StyledStatusLabel>
      </StyledTradeStatus>
      {!isSuccess && <StyledTip>{tipText}</StyledTip>}
    </div>
  )
}

export default CrossSwapOrderStatus

const StyledTradeStatus = styled.div`
  margin-top: 20px;
  padding: 16px 8px;
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.bgSurface};
`

const StyledStatusLabel = styled.p`
  margin: 12px 0 0 !important;
  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
  text-align: right;
  color: ${({ theme }) => theme.colors.textDisabled};
`

const StyledTip = styled.p`
  padding-top: 16px;
  font-weight: 400;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textCaption};
`
